__turbopack_context__.v({
  "gallery": "VideoGallery-module-scss-module__zsEg1G__gallery",
  "gallery__grid": "VideoGallery-module-scss-module__zsEg1G__gallery__grid",
  "gallery__heading": "VideoGallery-module-scss-module__zsEg1G__gallery__heading",
  "gallery__play": "VideoGallery-module-scss-module__zsEg1G__gallery__play",
  "gallery__poster": "VideoGallery-module-scss-module__zsEg1G__gallery__poster",
  "gallery__tile": "VideoGallery-module-scss-module__zsEg1G__gallery__tile",
});
